<template>
  <div class="room-group-video-film-container">
    <div class="room-group-video-body">
      <RoomCallMixingVideo
          v-for="ruv in roomGroup.roomUserVideos"
          :key="ruv.userId"
          :ref="`videos_group_user${ruv.userId}`"
          :video-rect="ruv"
          :room-group-id="roomGroup.roomGroupId"
          :mixer-video="true"
      />
    </div>
    <template v-if="!isInRoomGroup()">
      <RoomGroupVideoFilmHeader v-if="showRoomGroupVideoFilmHeader"
                                :roomGroup="roomGroup"
                                @close="() => this.showRoomGroupVideoFilmHeader = false"
      />
      <div v-else
           class="room-group-show-film-header"
      >
        <button class="room-group-btn-show-film-header"
                @click="() => this.showRoomGroupVideoFilmHeader = true"
        ></button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RoomCallMixingVideo from "@/components/Room/Call/mixing/RoomCallMixingVideo.vue";
import RoomGroupVideoFilmHeader from './RoomGroupVideoFilmHeader.vue'

export default {
  name: 'RoomGroupVideoFilmContainer',
  components: {
    RoomCallMixingVideo,
    RoomGroupVideoFilmHeader,
  },
  props: [
    'roomGroup'
  ],
  data() {
    return {
      showRoomGroupVideoFilmHeader: true
    }
  },
  computed: {
    ...mapGetters('roomGroup', [
      'isInRoomGroup'
    ]),

    roomGroupVideoBodyStyle() {
      return {
        height: `${this.roomGroup.videoHeight}px`,
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.room-group-video-film-container {
  width: 100%;
}
.room-group-video-body {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.room-group-show-film-header {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  display: flex;
  justify-content: flex-end;
}
.room-group-btn-show-film-header {
  width: 30px;
  height: 100%;
  transition: 0.1s ease-out;
  opacity: 0.5;
  &::before {
    content: '';
    width: 20px;
    height: 100%;
    margin: 0 auto;
    display: block;
    pointer-events: none;
    background: url('~@/assets/images/arrowLineThickTop_white.svg') no-repeat center / 75% auto;
  }
  &:hover {
    opacity: 0.9;
  }
}
</style>